import { render } from "./CreateWorkOrderForm.vue?vue&type=template&id=3d9d810c"
import script from "./CreateWorkOrderForm.vue?vue&type=script&lang=js"
export * from "./CreateWorkOrderForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__